export enum LoginErrorCode {
  AccountLocked = 423,
  LongerBetweenAttempts = 429,
}
